import { render, staticRenderFns } from "./LiveHeader.vue?vue&type=template&id=5de97f52&scoped=true&"
import script from "./LiveHeader.vue?vue&type=script&lang=ts&"
export * from "./LiveHeader.vue?vue&type=script&lang=ts&"
import style0 from "./LiveHeader.vue?vue&type=style&index=0&id=5de97f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de97f52",
  null
  
)

export default component.exports